export default () => {

  function decodeHashId(hash) {
    if (!hash || hash.charAt(0) !== '#') return null
    let id = hash.slice(1)
    try {
      id = decodeURIComponent(id)
    } catch {
      //
    }
    return id || null
  }

  function getHashTargetElement(hash) {
    const id = decodeHashId(hash)
    if (!id) return null
    return document.getElementById(id)
  }

  function applyScrollspyTargets($links) {
    const escaper = $.escapeSelector || (typeof CSS !== 'undefined' && CSS.escape ? CSS.escape : null)
    if (!escaper) return
    $links.each(function() {
      const id = decodeHashId(this.hash)
      if (!id) return
      $(this).attr('data-target', `#${escaper(id)}`)
    })
  }

  function findNavLinkByTarget($nav, target) {
    if (!target) return $()
    return $nav.find('a').filter(function() {
      return this.getAttribute('href') === target || this.getAttribute('data-target') === target
    })
  }

  const $nav = $('.js-subNavigation__navCol')

  if(!$nav.length) return

  const $slideLine =  $nav.find('.js-subNavigation__navMarker')
  let $currentItem = $nav.find('.c-subNavigation__navlistItem .active')

  if ( $currentItem.length ) {
    $('.c-subNavigation__navlistItem .active').removeClass('active')
    $currentItem.parent().addClass('active')
  }
  else {
    return
  }

  $nav.find('a').click(function(e) {
    e.preventDefault()
    $('.c-subNavigation__navlistItem').removeClass('c-subNavigation__navlistItem--active')
    const $activeEl = $(this).parent('li')
    $activeEl.addClass('c-subNavigation__navlistItem--active')
    $currentItem = $activeEl

    const targetEl = getHashTargetElement(this.hash)
    if (!targetEl) return
    const $el = $(targetEl)
    $('html, body').animate({
      scrollTop: $el.offset().top - 135,
    }, 1000)
  })

  function moveLine(item) {
    $slideLine.css({
      'width': item.width(),
      'left': item.position().left,
    })
  }

  if ($currentItem) {
    moveLine($currentItem)
  }

  $(window).resize( function() {
    moveLine($currentItem)
  })

  // Move underline on hover
  $nav.find('li').mouseenter(
    function(){
      $nav.removeClass('js-subNavigation--static')
      moveLine($(this))
      $slideLine.addClass('is-hovered')
    }
  )
  $nav.mouseleave(
    function(){
      if ($currentItem) {
        moveLine($currentItem)
      } else {
        $slideLine.width(0)
      }
      $slideLine.removeClass('is-hovered')
    }
  )


  // trigger hover event to ensure that underline has correct size
  setTimeout(function() {
    $('.c-subNavigation__navlistItem.active').trigger('mouseenter')
  }, 1000)

  applyScrollspyTargets($nav.find('a'))

  $('body').scrollspy({ target: '#c-subNavigationWrapper', offset: 140 })

  $(window).on('activate.bs.scrollspy', function (e,obj) {
    $nav.find('li').removeClass('is-underlined')
    const $activeItem = findNavLinkByTarget($nav, obj && obj.relatedTarget)
    if($activeItem.length) {
      $currentItem = $activeItem.parent()
      moveLine($currentItem)
      $('.c-subNavigation__navlistItem').removeClass('c-subNavigation__navlistItem--active')
      $activeItem.parent().addClass('c-subNavigation__navlistItem--active')
    }

  });

  const $toggle = $('.js-subNavigation__mobileHeader')
  const $navigation = $('.js-subNavigation')
  const classOpen = 'c-subNavigation--mobileOpen'
  const navlistCount = $navigation.find('.c-subNavigation__navlistItem').length;

  $navigation.addClass(`c-subNavigation--links-${navlistCount}`);

  $toggle.on('click', function () {
    if ($navigation.hasClass(classOpen)) {
      $navigation.removeClass(classOpen)
    } else {
      $navigation.addClass(classOpen)
    }
  })

  const mobileNavQuery = window.matchMedia('(min-width: 768px)');
  mobileNavQuery.addEventListener('change', (event) => {
    if (event.matches && $navigation.hasClass(classOpen)) {
      $navigation.removeClass(classOpen);
    }
  });

}
